/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// redux imports
import { getEntities } from "../../../../redux/features/Settings/Management/entities";

// components imports
import Loader from "../../../../components/Loader/Index";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import ICONS from "../../../../assets/Icons";

const EntitiesViewAll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchRef = useRef(null);
  const filterButtonRef = useRef(null);
  const filterRef = useRef(null);
  const applyBtnRef = useRef(null);
  const searchButtonRef = useRef(null);

  const { isLoading } = useSelector((state) => state.entities);

  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const [totalCount, setTotalCount] = useState(false);
  const [entitiesDetails, setEntitiesDetails] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [searchUserText, setSearchUserText] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [filterOpen, setFilterOpen] = useState(null);
  const [enitityID, setEntityID] = useState("");
  const [pageSize, setPageSize] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );
  const [selectedValue, setSelectedValue] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );
  const [nameSearch, setNameSearch] = useState("");
  const [panSearch, setPanSearch] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    const handleDropDown = (e) => {
      if (searchRef.current && searchRef.current.contains(e.target)) {
      } else if (
        searchButtonRef.current &&
        searchButtonRef.current.contains(e.target)
      ) {
      } else {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handleDropDown);
  }, [searchRef]);

  const fetchData = async () => {
    let queryParams = {
      page_no: currentPage,
      page_size: pageSize,
      search_string: nameSearch || panSearch || "",
      entity_id: enitityID || "",
    };

    try {
      setEntitiesDetails([]);
      setMainData([]);
      setTotalCount(GlobalConfiguration.lengthCheckZero);

      const response = await dispatch(getEntities(queryParams));

      const newData = response?.payload?.entities || [];

      setMainData(response?.payload || []);
      setTotalCount(response?.payload?.total_count);
      setEntitiesDetails(newData);
    } catch (error) {
      setMainData([]);
      setTotalCount(GlobalConfiguration.lengthCheckZero);
      setEntitiesDetails([]);
    } finally {
      setFetching(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
    if (event.key === "Enter") {
      applyBtnRef.current.click();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setFetching(true);
    fetchData();
  }, [nameSearch, panSearch, pageSize, currentPage, enitityID]);

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
      } else if (
        filterButtonRef.current &&
        filterButtonRef.current.contains(e.target)
      ) {
      } else {
        setFilterOpen((prev) => (prev === null ? null : false));
      }
    };
    document.addEventListener("click", handlefilter);
  }, [filterRef]);

  return (
    <>
      <div
        className={`bg-primary-bg flex flex-col h-screen relative overflow-y-hidden`}
        style={{
          overflow: filterOpen && "hidden",
        }}
      >
        <div className="Qsmd:min-h-navbar-breadcrumb-height bg-primary-nav"></div>
        <div className="relative z-z-index-dropdown">
          <TopNavComponent
            isFormattingNotRequired={true}
            topNavHeader={
              isLoading || fetching ? (
                <Loader height="var(--icon-md)" />
              ) : (
                totalCount
              )
            }
            topNavSubText={"Total entities"}
            handleBack={() => {
              if (filterOpen) {
                setFilterOpen(false);
              } else {
                navigate(GlobalConfiguration.navigate_back);
              }
            }}
            filteredSearchProps={{
              setActive: (val) => {
                setShowSearchBar(val);
              },
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: filterOpen,
              onSearchInput: (val) => {
                setSearchUserText(val);
              },
              searchText: searchUserText,
              searchPlaceholder: "Search entities",
              filterPlaceholder: "Name / address",
              filterItems: [
                {
                  name: "Search",
                  short_name: "Search",
                  isMulti: false,
                  value: nameSearch,
                  setValue: (val) => {
                    setNameSearch(val);
                    setCurrentPage(1);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value: panSearch,
                  setValue: (val) => {
                    setPanSearch(val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "Entity ID",
                  short_name: "Entity ID",
                  isMulti: false,
                  value: enitityID,
                  setValue: (val) => {
                    setEntityID(val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
              ],
              setIsFilterOpen: setFilterOpen,
              setIsSortOpen: () => {},
              loading: isLoading,
              isSortDisabled: isLoading,
              isFilterDisabled: isLoading,
            }}
          />
        </div>
        {showInnerSearchBar && (
          <div className="absolute top-[var(--navbar-breadcrumb-height)] left-left-base right-right-base bottom-bottom-base bg-PopUp-BackDrop opacity-light-opacity z-z-index-overlay" />
        )}
        {isLoading || fetching ? (
          <>
            <div className="loader-container m-auto justify-center items-center flex loader-height">
              <Loader />
            </div>
          </>
        ) : entitiesDetails.length !== GlobalConfiguration.lengthCheckZero ? (
          <>
            <div
              className={
                showInnerSearchBar
                  ? "overflow-y-hidden h-screen entitiesviewallscroll relative z-z-index-bas"
                  : `overflow-y-auto h-screen mb-margin-xl entitiesviewallscroll pb-padding-button-m ${showInnerSearchBar ? "mt-margin-xl Qsmd:mt-margin-base" : ""}`
              }
            >
              <div
                className={`${
                  showInnerSearchBar && "pointer-events-none "
                } standard-card-alignment gap-y-gap-md gap-x-gap-sm`}
              >
                {entitiesDetails.map(
                  ({ entity_id, entity_name, entity_pan }) => {
                    return (
                      <>
                        <CardContainer
                          onClickHandler={(e, c) => {
                            const isViewAll = location.pathname.includes(
                              `settings/entities_view_all`,
                            );

                            navigate(`entities_detail_page/${entity_id}`, {
                              state: { isViewAll },
                            });
                          }}
                        >
                          <card-body>
                            <TextWithIcon
                              type={"text"}
                              fontWeight={"semibold"}
                              text={entity_name}
                              textColor={"var(--text-primary)"}
                            />
                            <TextWithIcon
                              type={"text"}
                              fontWeight={"normal"}
                              subText={"PAN number"}
                              text={entity_pan}
                              textColor={"var(--text-primary)"}
                            />
                          </card-body>
                        </CardContainer>
                      </>
                    );
                  },
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className={
                filterOpen
                  ? "h-height-full w-width-full flex flex-col items-center justify-center m-auto pointer-events-none"
                  : "flex flex-col items-center justify-center m-auto"
              }
            >
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt="No accounts found"
                className="w-graphic-width-md h-graphic-rectangle-height-md"
                style={{
                  opacity: filterOpen
                    ? "var(--light-opacity)"
                    : "var(--opacity-base)",
                }}
              />
              <p
                className={
                  filterOpen
                    ? "no-owneraccount-text-opacity"
                    : "text-font-sm opacity-base-opacity py-padding-sm text-text-primary"
                }
              >
                No data found.
              </p>
              <PrimaryButton
                handleFunction={() => {
                  setSearchUserText("");
                  setEntityID("");
                  setNameSearch("");
                  setCurrentPage(1);
                  setPanSearch("");
                }}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                btnText="Clear parameters"
                hoverOption="white"
                btnType="button"
              />
            </div>
          </>
        )}
        {entitiesDetails.length !== GlobalConfiguration.lengthCheckZero && (
          <>
            <div
              style={{
                zIndex: showInnerSearchBar
                  ? "var(--z-index-content)"
                  : "var(--z-index-max)",
                width: "var(--width-full)",
                bottom: "var(--bottom-base)",
              }}
              className="fixed w-full"
            >
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                setIsOpen={(e) => {}}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EntitiesViewAll;
